import { HashLink } from "react-router-hash-link";
import Navbar from "./Navbar";
import aboutImage from "../Assets/aboutImage.png";
import landingImage from "../Assets/landingImage.png";

import Portfolio from "./Portfolio";
import Contact from "./Contact";
import Slide1 from "./Slide1";
import Footer from "./Footer";
import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function Landing() {
  const [fade, setFade] = useState(false);

  useEffect(() => {
    setFade(true);

    return () => {
      // Clean up any lingering timeouts
      clearTimeout();
    };
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
      once: true,
    });
  });

  const onClick = () => {
    fetch("Inge_Radyn_CV.pdf").then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);

        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "Inge_Radyn_CV.pdf";
        alink.click();
      });
    });
  };

  return (
    <div className="home-container" id="top">
      <div className={`overlay${fade ? " fade-out" : ""}`}></div>
      <div className={`content${fade ? " fade-in" : ""}`}>
        <div className="landing">
          <Navbar />
          <hr />
          <div className="landing-container">
            <div className="content-div">
              <div className="text1">
                <p
                  className="landing-page-heading"
                  data-aos="fade-up"
                  data-aos-anchor-placement="bottom-bottom"
                  data-aos-delay="300"
                >
                  Hi, I'm Inge, <br />
                  <span>
                    an intuitive <br /> Product Designer
                  </span>
                </p>
              </div>
              <div className="profile-photo-div">
                <img className="profile-img" src={aboutImage} alt="  " />
                <div
                  className="text2"
                  data-aos="fade-up"
                  data-aos-anchor-placement="bottom-bottom"
                  data-aos-delay="1200"
                  data-aos-duration="1500"
                >
                  <p className="profile-hero-text">
                  As part of the NML team I am currently leaving my design mark in the fintech industry, crafting financial platforms from scratch, working on design systems and simplifying the process of managing investments through user friendly design.
                  </p>
                  {/* <HashLink smooth to="/landing#portfolio">
                    <div className="view-portfolio">
                      <svg
                        width="135"
                        height="37"
                        viewBox="0 0 142 37"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.136 33H5.664L8.752 24.424H6.656L4.672 30.472L4.464 31.4L4.24 30.472L2.256 24.424H0.048L3.136 33ZM9.74088 23.464H11.7889V21.48H9.74088V23.464ZM9.74088 33H11.7889V24.424H9.74088V33ZM21.4868 30.2H19.3268C19.0548 31.112 18.3988 31.56 17.4388 31.56C16.1908 31.56 15.4708 30.696 15.3748 29.128H21.4228V28.648C21.4228 25.88 19.8708 24.184 17.3588 24.184C14.8628 24.184 13.2628 25.816 13.2628 28.728C13.2628 31.528 14.8468 33.24 17.4388 33.24C19.4868 33.24 21.0228 32.184 21.4868 30.2ZM17.3588 25.864C18.4308 25.864 19.0868 26.568 19.2788 27.848H15.4228C15.6148 26.552 16.2708 25.864 17.3588 25.864ZM30.4499 33H33.0099L35.4099 24.424H33.3139L31.9219 30.472L31.7299 31.48L31.5219 30.472L29.8739 24.424H27.7459L26.0979 30.472L25.8579 31.512L25.6499 30.472L24.2739 24.424H22.0819L24.4659 33H27.0099L28.5459 27.256L28.7379 26.248L28.8979 27.256L30.4499 33ZM41.6326 36.52V32.072C42.1606 32.84 42.9446 33.24 43.8886 33.24C46.0966 33.24 47.5046 31.608 47.5046 28.696C47.5046 25.896 46.1286 24.184 43.8886 24.184C42.9446 24.184 42.1766 24.616 41.6326 25.4V24.424H39.5846V36.52H41.6326ZM43.5206 25.88C44.7206 25.88 45.3926 26.888 45.3926 28.696C45.3926 30.536 44.7366 31.544 43.5206 31.544C42.3206 31.544 41.6326 30.52 41.6326 28.696C41.6326 26.872 42.2886 25.88 43.5206 25.88ZM52.7029 33.24C55.1829 33.24 56.7989 31.608 56.7989 28.728C56.7989 25.912 55.2309 24.184 52.7029 24.184C50.2069 24.184 48.5909 25.816 48.5909 28.728C48.5909 31.528 50.1589 33.24 52.7029 33.24ZM52.7029 31.544C51.4069 31.544 50.7029 30.536 50.7029 28.728C50.7029 26.888 51.3909 25.88 52.7029 25.88C53.9829 25.88 54.6869 26.904 54.6869 28.728C54.6869 30.552 53.9989 31.544 52.7029 31.544ZM58.2878 33H60.3358V28.44C60.3358 27.016 61.0238 26.088 62.5758 26.088C62.9438 26.088 63.2478 26.12 63.5198 26.2V24.424C63.3598 24.28 63.0398 24.184 62.6878 24.184C61.7598 24.184 60.8958 24.648 60.3358 25.672V24.424H58.2878V33ZM64.8723 30.328C64.8723 32.248 65.7043 33.24 67.4483 33.24C68.0083 33.24 68.4723 33.144 68.6963 33.032V31.528H68.3123C67.1763 31.528 66.9203 31.048 66.9203 30.152V26.008H68.7283V24.424H66.9203V22.456H64.8723V24.424H63.7683V26.008H64.8723V30.328ZM69.0644 26.008H70.1684V33H72.2164V26.008H73.7844V24.424H72.2164V24.152C72.2164 23.24 72.4884 22.776 73.6244 22.776H73.7844V21.448C73.5764 21.352 73.1924 21.24 72.6644 21.24C71.0324 21.24 70.1684 22.216 70.1684 24.152V24.424H69.0644V26.008ZM78.4685 33.24C80.9485 33.24 82.5645 31.608 82.5645 28.728C82.5645 25.912 80.9965 24.184 78.4685 24.184C75.9725 24.184 74.3565 25.816 74.3565 28.728C74.3565 31.528 75.9245 33.24 78.4685 33.24ZM78.4685 31.544C77.1725 31.544 76.4685 30.536 76.4685 28.728C76.4685 26.888 77.1565 25.88 78.4685 25.88C79.7485 25.88 80.4525 26.904 80.4525 28.728C80.4525 30.552 79.7645 31.544 78.4685 31.544ZM84.0534 33H86.1014V21.48H84.0534V33ZM87.9753 23.464H90.0233V21.48H87.9753V23.464ZM87.9753 33H90.0233V24.424H87.9753V33ZM95.6091 33.24C98.0891 33.24 99.7051 31.608 99.7051 28.728C99.7051 25.912 98.1371 24.184 95.6091 24.184C93.1131 24.184 91.4971 25.816 91.4971 28.728C91.4971 31.528 93.0651 33.24 95.6091 33.24ZM95.6091 31.544C94.3131 31.544 93.6091 30.536 93.6091 28.728C93.6091 26.888 94.2971 25.88 95.6091 25.88C96.8891 25.88 97.5931 26.904 97.5931 28.728C97.5931 30.552 96.9051 31.544 95.6091 31.544ZM111.856 33H114.416L116.816 24.424H114.72L113.328 30.472L113.136 31.48L112.928 30.472L111.28 24.424H109.152L107.504 30.472L107.264 31.512L107.056 30.472L105.68 24.424H103.488L105.872 33H108.416L109.952 27.256L110.144 26.248L110.304 27.256L111.856 33ZM121.578 33.24C124.058 33.24 125.674 31.608 125.674 28.728C125.674 25.912 124.106 24.184 121.578 24.184C119.082 24.184 117.466 25.816 117.466 28.728C117.466 31.528 119.034 33.24 121.578 33.24ZM121.578 31.544C120.282 31.544 119.578 30.536 119.578 28.728C119.578 26.888 120.266 25.88 121.578 25.88C122.858 25.88 123.562 26.904 123.562 28.728C123.562 30.552 122.874 31.544 121.578 31.544ZM127.163 33H129.211V28.44C129.211 27.016 129.899 26.088 131.451 26.088C131.819 26.088 132.123 26.12 132.395 26.2V24.424C132.235 24.28 131.915 24.184 131.563 24.184C130.635 24.184 129.771 24.648 129.211 25.672V24.424H127.163V33ZM133.475 33H135.523V28.856L138.755 33H141.267L137.571 28.232L141.027 24.424H138.627L135.523 28.008V21.48H133.475V33Z"
                          fill="#20211D"
                        />
                        <path
                          d="M110.354 4.35355C110.549 4.15829 110.549 3.84171 110.354 3.64645L107.172 0.464466C106.976 0.269204 106.66 0.269204 106.464 0.464466C106.269 0.659728 106.269 0.976311 106.464 1.17157L109.293 4L106.464 6.82843C106.269 7.02369 106.269 7.34027 106.464 7.53553C106.66 7.7308 106.976 7.7308 107.172 7.53553L110.354 4.35355ZM31 4.5H110V3.5H31V4.5Z"
                          fill="#20211D"
                        />
                      </svg>
                    </div>
                  </HashLink> */}
                </div>
              </div>
            </div>
            <div className="image-container">
              <img className="landing-img" src={landingImage} alt="" />
              <div className="text-overlay">
                <p data-aos="fade-up"  data-aos-delay="500">
                  design<br />that exists for a reason.
                </p>
                <HashLink
                  smooth
                  to="/landing#about"
                  className="desktop-scroll-btn"
                >
                  <button className="view-skills-btn">more about me</button>
                </HashLink>
                <HashLink
                  smooth
                  to="/landing#mobileAbout"
                  className="mobile-scroll-btn"
                >
                  <button className="view-skills-btn">more about me</button>
                </HashLink>
              </div>
            </div>
          </div>
          <hr />
        </div>
        <Slide1 />
        {/* <Skills /> */}
        <Portfolio />
        <Contact />
        <Footer onClick={onClick} />
      </div>
    </div>
  );
}

export default Landing;
